import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAJos1CeTbg6R_cBu6ePw_RC8naTpj0OnY",
  authDomain: "immalta.firebaseapp.com",
  projectId: "immalta",
  storageBucket: "immalta.firebasestorage.app",
  messagingSenderId: "1083597843974",
  appId: "1:1083597843974:web:75fc659ae2bb97639c5d87"
};

export const app = initializeApp(firebaseConfig);